export { clearData, useTinRegistrationStatus } from './hooks';
export { tinRegistarationStatusReducer } from './reducer';
